﻿<div class="row">
    <div class="col-sm-4">
        <dashboard-documents></dashboard-documents>
    </div>
    <div class="col-sm-8">
        <dashboard-upcoming-relieves></dashboard-upcoming-relieves>
    </div>
</div>